//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { topNavSearchClear } from '@tidal/styles-icons';
import { tidalTransitionExpand } from '@tidal/styles-animation';

export const COOKIE_NAME = 'intro-banner-hidden';

export default {
    components: {
        tidalTransitionExpand,
    },
    props: {
        hidden: {
            type: Boolean,
            default: false,
        },
        /** @type {import('vue').PropOptions<TIDAL.SubscriptionInfo>} */
        subscriptionInfo: {
            type: Object,
            required: true,
        },
    },
    computed: {
        icons() {
            return { topNavSearchClear };
        },
        /** @return {string} */
        startSubscriptionLink() {
            return `/user/subscription/start?lang=${this.$i18n.localeProperties.lang}`;
        },
    },
};
